import { render } from "./WhatSalesTogether.vue?vue&type=template&id=6212a3b2"
import script from "./WhatSalesTogether.vue?vue&type=script&lang=js"
export * from "./WhatSalesTogether.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__